import React,
{
    useEffect,
    useState
}
from "react";

import {
    Line
}
from "react-chartjs-2";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend
}
from "chart.js";

import {
    getStats
}
from "../services/shortLinkService";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend
);

export default function StatsModal({
    currentUser,
    code,
    onClose
}) {

    const [stats, setStats] =
        useState(null);

    const [loading, setLoading] =
        useState(true);

    useEffect(() => {

        async function loadStats() {

            try {

                const data =
                    await getStats(
                        currentUser,
                        code
                    );

                setStats(data);

            }

            catch (err) {

                console.error(err);

            }

            finally {

                setLoading(false);

            }

        }

        if (code) {
            loadStats();
        }

    }, [
        currentUser,
        code
    ]);

    if (!code) {
        return null;
    }

    if (loading) {

        return (

            <div className="modalOverlay">

                <div className="modalCard">

                    Loading statistics...

                </div>

            </div>

        );

    }

    if (!stats) {

        return (

            <div className="modalOverlay">

                <div className="modalCard">

                    Unable to load statistics.

                </div>

            </div>

        );

    }

    const dayLabels =
        Object.keys(
            stats.clicksByDay || {}
        ).sort();

    const dayValues =
        dayLabels.map(
            day =>
                stats.clicksByDay[day]
        );

    const chartData = {

        labels:
            dayLabels,

        datasets: [

            {
                label:
                    "Clicks",

                data:
                    dayValues,

                tension:
                    0.3

            }

        ]

    };

    const lastClicked =
        stats.link.lastClickedAt
            ? new Date(
                stats.link.lastClickedAt._seconds * 1000
              ).toLocaleString()
            : "Never";

    return (

        <div
            className="modalOverlay"
            onClick={onClose}
        >

            <div
                className="modalCard"
                onClick={e =>
                    e.stopPropagation()
                }
            >

            <div className="statsHeader">

                <div>

                    <h2 className="statsHeaderTitle">
                        {stats.link.title}
                    </h2>

                    <div className="statsSubtitle">

                        {stats.link.shortCode}

                    </div>

                </div>

                <button
                    className="closeButton"
                    onClick={onClose}
                >
                    ×
                </button>

            </div>

                <div className="statsGrid">

                    <div className="statCard">

                        <div className="statNumber">
                            {
                                stats.link.clickCount || 0
                            }
                        </div>

                        <div>
                            Total Clicks
                        </div>

                    </div>

                    <div className="statCard">

                        <div className="statNumber">
                            {
                                stats.uniqueVisitors || 0
                            }
                        </div>

                        <div>
                            Unique Visitors
                        </div>

                    </div>

                    <div className="statCard">

                        <div className="statNumber">
                            {
                                stats.qrClicks || 0
                            }
                        </div>

                        <div>
                            QR Scans
                        </div>

                    </div>

                    <div className="statCard">

                        <div className="statNumber">
                            {
                                stats.directClicks || 0
                            }
                        </div>

                        <div>
                            Direct Visits
                        </div>

                    </div>

                </div>

                <p className = "statsInfo">

                    <strong>
                        Short Code:
                    </strong>

                    {" "}
                    {stats.link.shortCode}

                </p>

                <p className = "statsInfo">

                    <strong>
                        Destination:
                    </strong>

                    {" "}

                    <a
                        href={
                            stats.link.destinationUrl
                        }
                        target="_blank"
                        rel="noreferrer"
                    >
                        {
                            stats.link.destinationUrl
                        }
                    </a>

                </p>

                <p className = "statsInfo">

                    <strong>
                        Last Click:
                    </strong>

                    {" "}

                    {lastClicked}

                </p>

                <h3 className = "statsInfo">
                    Clicks by Day
                </h3>

                <div className="chartContainer">

                    <Line
                        data={chartData}
                        options={{
                            maintainAspectRatio: false
                        }}
                    />

                </div>

                <h3 className = "statsInfo">
                    Top Referrers
                </h3>

                {

                    (stats.topReferrers || [])
                    .map(ref => (

                        <div
                            key={ref.name}
                            className="referrerRow"
                        >

                            <span>
                                {ref.name}
                            </span>

                            <strong>
                                {ref.count}
                            </strong>

                        </div>

                    ))

                }

                <h3 className = "statsInfo">
                    Clicks by Month
                </h3>

                <ul>

                    {

                        Object.entries(
                            stats.clicksByMonth || {}
                        )

                        .sort()

                        .map(
                            ([month, count]) => (

                                <li key={month}>

                                    {month}: {count}

                                </li>

                            )
                        )

                    }

                </ul>

                <h3 className = "statsInfo">
                    Recent Clicks
                </h3>

                <table
                    className="statsTable"
                >

                    <thead>

                        <tr>

                            <th>
                                Time
                            </th>

                            <th>
                                IP
                            </th>

                            <th>
                                Source
                            </th>

                            <th>
                                Referrer
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            stats.recentClicks.map(
                                click => (

                                    <tr
                                        key={click.id}
                                    >

                                        <td>

                                            {

                                                click.timestamp

                                                ?

                                                new Date(
                                                    click.timestamp._seconds * 1000
                                                ).toLocaleString()

                                                :

                                                ""

                                            }

                                        </td>

                                        <td>
                                            {click.ip}
                                        </td>

                                        <td>
                                            {click.source}
                                        </td>

                                        <td>
                                            {
                                                click.referrer ||
                                                "Direct"
                                            }
                                        </td>

                                    </tr>

                                )
                            )

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

}